import * as Yup from 'yup';
import {
  TEXT_AREA_LENGTH,
  WISHLIST_NAME_LENGTH,
  createOptionalStringFieldSchema,
  createStringFieldSchema
} from '@spa/lib/formsSchemas/commonValidations';
import { FormatMessageFunction } from '@spa/lib/i18n/common/FormatMessageFunction';
import { Schema } from 'yup';
import { WishlistFormFields } from '@spa/components/forms/wishlist-form/wishlistFormTypes';

const WishlistFormSchemaValidation = (
  formatMessage: FormatMessageFunction
): Schema<WishlistFormFields> => {
  return Yup.object({
    name: createStringFieldSchema(WISHLIST_NAME_LENGTH, formatMessage),
    description: createOptionalStringFieldSchema(TEXT_AREA_LENGTH, formatMessage, true)
  });
};

export default WishlistFormSchemaValidation;
